import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoundService {

  private audio = new Audio();

  constructor() { }

  playSound() {


    this.audio.src = './assets/sounds/sound.mp3';
    this.audio.loop = true;
    this.audio.load();
    let resp = this.audio.play();
    console.log(resp);
  if (resp !== undefined) {
      resp.then(_ => {
        let sound = document.getElementsByTagName('audio');
        if(sound.length > 0){
          sound[0].parentNode.removeChild(sound[0]);
        }
        document.body.appendChild(this.audio);
          // autoplay starts!
      }).catch(error => {
        console.log(error);
        //show error
      });
    }
  }

  playSoundAlert() {

    this.audio.src = './assets/sounds/soundAlert.mp3';
    this.audio.loop = true;
    this.audio.load();
    let resp = this.audio.play();

  if (resp !== undefined) {
      resp.then(_ => {
        setTimeout(() => {
          this.audio.pause();
        }, 3000);
          // autoplay starts!
      }).catch(error => {
        //show error
      });
    }
  }
}

/* setTimeout(() => {
          this.audio.pause();
        }, 60000); */
        //document.body.appendChild(this.audio);
